import React from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'

const OnBoardingRedirect = ({ oidc }) => {
  return (
    <div
      className='col-12 border-bottom-lg border-color-featured bg-white pt-3 pb-1 mr-auto ml-auto'
    >
      <div className='row px-3 border-color-ui-3 border-bottom pb-2'>
        <div className='col-11'>
          <h3 id='modalTitle'>Verificação em 2 etapas</h3>
        </div>
        <div className='col-1 text-right'>
          <Button
            name={'Close'}
            className='btn btn-double btn-flat btn-icon-only btn-icon d-none'
            iconName='icon_close icon-sm'
            text=''
          />
        </div>
      </div>
      <div className='col-12'>
        <div className='row'>
          <div className='col-12 mt-3 mb-1'>
            <div className='row mx-1'>
              <div className='col-12 row modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0'>
                <p className='col-12 txt-body-sm txt-bold pb-1 px-0  color-brand-1'>
                  Você ainda não possui nenhum celular verificado.
                </p>
                <p className='col-12 txt-body-sm pb-2 px-0'>
                  Realizar essa verificação é muito importante para que seus
                  resgates no
                  <br />
                  Catálogo de Prêmios ocorram de forma segura. Assim saberemos
                  que apenas
                  <br />
                  você estará utilizando seus pontos e não um possível
                  fraudador.
                </p>
                <div className='col-12 col-md-6 row'>
                  <Button
                    className='btn btn-double btn-featured btn-rating-modal2 col-12'
                    text='VERIFIQUE AGORA'
                    onClick={() =>
                      window.open(
                        process.env.REACT_APP_ONBOARDING_ENDPOINT +
                          oidc.user.profile['custom:campaign_id'],
                        '_self'
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

OnBoardingRedirect.propTypes = {
  oidc: PropTypes.object
}

export default OnBoardingRedirect



// WEBPACK FOOTER //
// ./src/features/Checkout/SecondFactorAuthenticaton/OnBoardingRedirect.js